import StripChatVideo from "./StripChatVideo";
import { IModel } from "services/StripChatService";
import { className } from "utils";
import { shallowEqual, useSelector } from "react-redux";
import { IAppState } from "store/app-state";
import classes from "./StripChat.module.scss";

interface IProps {
  model?: IModel;
}

const StripChat = ({ model }: IProps) => {
  const { isFullScreen } = useSelector((state: IAppState) => state.application, shallowEqual);

  return (
    <div
      className={className({
        Player: true,
        [classes.StripChatPlayer]: true,
      })}
      style={{
        height: `${window.innerHeight}px`,
      }}
    >
      { isFullScreen && (
        <StripChatVideo
          previewUrl={model?.previewUrl}
          videoUrl={model?.stream.url}
          avatarUrl={model?.avatarUrl}
          username={model?.username}
          width={model?.stream.width}
          height={model?.stream.height}
        />
      )}
    </div>
  );
};

export default StripChat;
